import { plurals } from '@components/utils';

import type { ILocale } from './';

export default {
  notification: {
    closeLabel: 'Закрыть'
  },
  table: {
    filterTitle: 'Фильтр меню',
    filterConfirm: 'Выбрать',
    filterReset: 'Сброс',
    filterEmptyText: 'Нет фильтров',
    filterCheckAll: 'Выбрать все элементы',
    filterSearchPlaceholder: 'Поиск фильтров',
    emptyText: 'Нет данных',
    selectAll: 'Выбрать текущую страницу',
    selectInvert: 'Инвертировать текущую страницу',
    selectNone: 'Очистить все данные',
    selectionAll: 'Выбрать все данные',
    sortTitle: 'Сортировка',
    expand: 'Раскрыть строку',
    collapse: 'Свернуть строку',
    triggerDesc: 'Отсортировать по убыванию',
    triggerAsc: 'Отсортировать по возрастанию',
    cancelSort: 'Отменить сортировку',
    showed: 'Отображено',
    from: 'из',
    rowOnPage: 'Строк на странице'
  },
  date: {
    days: 'Воскресенье_Понедельник_Вторник_Среда_Четверг_Пятница_Суббота'.split('_'),
    daysShort: 'Вс_Пн_Вт_Ср_Чт_Пт_Сб'.split('_'),
    months: 'Январь_Февраль_Март_Апрель_Май_Июнь_Июль_Август_Сентябрь_Октябрь_Ноябрь_Декабрь'.split('_'),
    monthsLong: 'Января_Февраля_Марта_Апреля_Мая_Июня_Июля_Августа_Сентября_Октября_Ноября_Декабря'.split('_'),
    monthsShort: 'Янв_Февр_Март_Апр_Май_Июнь_Июль_Авг_Сент_Окт_Нояб_Дек'.split('_'),
    today: 'Сегодня',
    firstDayOfWeek: 1, // 0-6, 0 - Sunday, 1 Monday, ...
    format24h: true,
    pluralDay: (day: number) => plurals(day, ['день', 'дня', 'дней'])
  },
  time: {
    now: 'Текущее время'
  },
  container: {
    prev: 'Предыдущий',
    next: 'Следующий'
  },
  slideView: {
    prev: 'Предыдущий',
    next: 'Следующий'
  },
  uploader: {
    uploading: 'Загрузка',
    uploadFile: 'Загрузить файл',
    downloadFile: 'Скачать файл',
    removeFile: 'Удалить файл',
    uploadError: 'Ошибка загрузки',
    previewFile: 'Предпросмотр файла'
  },
  dropdown: {
    noData: 'Нет данных',
    selectAll: 'Выбрать все'
  }
} as ILocale;
